export default __webpack_public_path__ + "static/media/carousel-item-01.f64b0928.jpg";